import React, { memo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Listbox, Transition } from '@headlessui/react';
import {
  AiOutlineDown as SelectorIcon,
  AiOutlineCheck as CheckIcon,
} from 'react-icons/ai';
import cn from 'classnames';

function FormMenu({
  options,
  onChange,
  label,
  placeHolder,
  value,
  className,
  required,
}) {
  return (
    <div>
      <Listbox value={value} onChange={onChange}>
        {label && (
          <Listbox.Label className="block text-xs font-medium text-primary-500">
            <span>{label}</span>
            {required && (
              <span className="ml-1 font-light text-red-500">*</span>
            )}
          </Listbox.Label>
        )}
        <div className="relative mt-1">
          <Listbox.Button
            className={cn(
              'border border-slate relative w-full py-2 sm:py-4 pl-6 pr-10 text-left bg-white cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-primary focus-visible:ring-offset-2 focus-visible:border-primary text-base',
              className,
            )}
          >
            <span className="block truncate text-sm">
              {value ?? placeHolder}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
              <SelectorIcon
                className="w-4 h-4 text-primary"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="w-full z-50 absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {options.map((option) => (
                <Listbox.Option
                  key={JSON.stringify(option)}
                  className={({ active }) =>
                    `${
                      active
                        ? 'text-secondary-900 bg-secondary-200'
                        : 'text-gray-900'
                    }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                  }
                  value={option}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`${
                          selected ? 'font-medium' : 'font-normal'
                        } block truncate`}
                      >
                        {option}
                      </span>
                      {selected ? (
                        <span
                          className={`${
                            active ? 'text-secondary-600' : 'text-secondary-600'
                          }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                        >
                          <CheckIcon className="w-5 h-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}

FormMenu.defaultProps = {
  className: '',
  value: '',
  label: '',
  placeHolder: 'Select an option',
  required: false,
};

FormMenu.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeHolder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  required: PropTypes.bool,
};

export default memo(FormMenu);
